<div class="trusted-container">
  <h2>Trusted by community of 10000+ teachers and schools</h2>
  <div *ngIf="logoUrl?.length">
    <div class="carousel-container">
      <div class="carousel-images">
        <!-- <ng-image-slider [animationSpeed]="1" [images]="school.gallery" #gallery></ng-image-slider> -->
        <!-- <ng-image-slider [imageSize]="imageSize" [autoSlide]="autoSlide" [infinite]="infiniteSlide"
              [showArrow]="true" [animationSpeed]="4" [slideImage]="4" [images]="logoUrl" #gallery></ng-image-slider> -->
        <!-- <ng-image-slider [imageSize]="imageSize" [autoSlide]="autoSlide" [infinite]="infiniteSlide"
                    [showArrow]="false" [animationSpeed]="1" [images]="logoUrl" #gallery></ng-image-slider> -->
      </div>
    </div>
  </div>
</div>
